import { Box, Button, Typography } from "@mui/material";

export default function Service({ title, description, btnText, icon, id }) {
  return (
    <Box className="logo service-type" id={id}>
      {icon}
      <Typography variant="h4" className="text-[cyan]">
        {title}
      </Typography>
      <Typography variant="body1" className="text-white my-2">
        {description}
      </Typography>
      <Button
        component="a"
        href="#contact"
        variant="contained"
        className="hover:shadow-[0_0_5px_2px_#0ef]"
      >
        {btnText}
      </Button>
    </Box>
  );
}
